export default __webpack_public_path__ + "fonts/5710f86087dc84a4b971b614d8be3616.woff";